/**
 * MSW inline responses for the team member Activity panel and the "Log Jamie Meeting" flow
 * (`/apollo/people/team/meetings/*`). Spread into the ENV-wide map in `inlineResponses.tsx`.
 *
 * People-module data must never come from a real export, so this is hand-authored, obviously-fake
 * data (invented names, synthetic ids).
 */
export const PEOPLE_TEAM_MEETINGS_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Activity-panel list of logged meetings for a team member.
  "/apollo/people/team/meetings/for-team-member": [
    {
      teamMemberMeetingId: "tm100000-0000-4000-8000-000000000001",
      title: "1:1 — Avery Stone",
      meetingDate: "2025-01-14T17:00:00Z",
      summaryShort:
        "Discussed winter peak coverage plan and growth goals for the quarter.",
      createdAt: "2025-01-14T18:05:00Z",
      createdBy: "test@freightsimple.com",
    },
    {
      teamMemberMeetingId: "tm100000-0000-4000-8000-000000000002",
      title: "Quarterly review — Avery Stone",
      meetingDate: "2024-10-02T16:00:00Z",
      summaryShort:
        "Strong quarter. Agreed to take ownership of the carrier onboarding checklist.",
      createdAt: "2024-10-02T17:10:00Z",
      createdBy: "test@freightsimple.com",
    },
  ],

  // Full snapshot for the meeting detail dialog.
  "/apollo/people/team/meetings/tm100000-0000-4000-8000-000000000001": {
    teamMemberMeetingId: "tm100000-0000-4000-8000-000000000001",
    title: "1:1 — Avery Stone",
    meetingDate: "2025-01-14T17:00:00Z",
    jamieUrl: "https://app.meetjamie.ai/meetings/jm-synthetic-0001",
    summaryMarkdown:
      "# 1:1 — Avery Stone\n\nCovered the winter peak coverage plan and quarterly growth goals. Avery wants to take on more carrier-facing work next quarter.\n\n**Follow-up:** pair on the carrier onboarding checklist.",
    transcript:
      "Manager\n\n00:00 - 00:05\n\nThanks for making time — how did the peak coverage plan land?\n\nAvery\n\n00:05 - 00:20\n\nReally well. The rotation held up and nobody was double-booked.",
    notes: "Great momentum. Revisit growth goals at the next quarterly.",
    participantsJson:
      '[{"name":"Test Manager","email":"test@freightsimple.com"},{"name":"Avery Stone","email":"avery.stone@freightsimple.com"}]',
    actionItemsJson:
      '[{"content":"Pair on the carrier onboarding checklist","completed":false,"assignee":{"name":"Avery Stone","email":"avery.stone@freightsimple.com"}}]',
    createdBy: "test@freightsimple.com",
  },

  // The current user's recent Jamie meetings, offered in the Log Jamie Meeting picker.
  "/apollo/people/team/meetings/recent-meetings": [
    {
      jamieMeetingId: "jm-synthetic-0001",
      title: "1:1 — Avery Stone",
      meetingDate: "2025-01-14T17:00:00Z",
    },
    {
      jamieMeetingId: "jm-synthetic-0002",
      title: "Ops weekly sync",
      meetingDate: "2025-01-13T15:30:00Z",
    },
  ],

  // POST preview — the parsed meeting for the review step.
  "/apollo/people/team/meetings/preview": {
    jamieMeetingId: "jm-synthetic-0001",
    jamieUrl: "https://app.meetjamie.ai/meetings/jm-synthetic-0001",
    title: "1:1 — Avery Stone",
    meetingDate: "2025-01-14T17:00:00Z",
    summaryShort:
      "Discussed winter peak coverage plan and growth goals for the quarter.",
    summaryMarkdown:
      "# 1:1 — Avery Stone\n\nCovered the winter peak coverage plan and quarterly growth goals.",
    participants: [
      { name: "Test Manager", email: "test@freightsimple.com" },
      { name: "Avery Stone", email: "avery.stone@freightsimple.com" },
    ],
    actionItems: [
      {
        content: "Pair on the carrier onboarding checklist",
        assignee: "Avery Stone",
      },
    ],
  },

  // POST log — returns the new meeting id.
  "/apollo/people/team/meetings/log": {
    teamMemberMeetingId: "tm100000-0000-4000-8000-000000000001",
  },
};
